/**
 * @generated SignedSource<<bc0ed3c28b96e92de244d3852535bcd2>>
 * @relayHash 9ab744ce20e2191f4f062c022069bf93
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/567.0.0-2026-07-09T16:56:40.509Z/designsRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type designsRootQuery$variables = Record<PropertyKey, never>;
export type designsRootQuery$data = {
  readonly viewer: {
    readonly iconicDesignsDirectoryPage: {
      readonly bannerImages: ReadonlyArray<{
        readonly imageUrl: string | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"DesignsLayout_viewer">;
  };
};
export type designsRootQuery = {
  response: designsRootQuery$data;
  variables: designsRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "designsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IconicDesignsDirectoryPage",
            "kind": "LinkedField",
            "name": "iconicDesignsDirectoryPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IconicDesignBannerImageUrl",
                "kind": "LinkedField",
                "name": "bannerImages",
                "plural": true,
                "selections": [
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DesignsLayout_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "designsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IconicDesignsDirectoryPage",
            "kind": "LinkedField",
            "name": "iconicDesignsDirectoryPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IconicDesignBannerImageUrl",
                "kind": "LinkedField",
                "name": "bannerImages",
                "plural": true,
                "selections": [
                  (v0/*:: as any*/),
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IconicDesignsDirectoryListObject",
                "kind": "LinkedField",
                "name": "directory",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IconicDesignsDirectoryListDesigns",
                    "kind": "LinkedField",
                    "name": "designs",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creators",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlLabel",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IconicDesignPage",
                "kind": "LinkedField",
                "name": "designPages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "designName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "designUri",
                    "storageKey": null
                  },
                  (v0/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IconicDesignCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "isDesignsDirectoryQuickJumpDisabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "isDesignsDirectoryQuickJumpDisabled"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": "isEnabled(key:\"isDesignsDirectoryQuickJumpDisabled\")"
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/567.0.0-2026-07-09T16:56:40.509Z/designsRootQuery",
    "metadata": {},
    "name": "designsRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d7bcc7a6fc4e062eebe32b75e400785e";

export default node;
